/**
 * Signed-out state.
 *
 * One button rather than separate sign-in and create-account links: the loyalty drawer it opens
 * already offers both paths, so splitting them here only asked the shopper a question the next
 * screen asks again.
 *
 * It must not navigate. `/account/login` and `/account/register` both run
 * `window.location.replace('/?modal=account')` (sections/account/account-login.liquid), so the
 * old links bounced to the homepage and dropped their return_url — the PDP, the drawer and the
 * pending save were all lost, which is why signing in from the wishlist appeared to be broken.
 * openLoginDrawer() opens the same loyalty drawer over this one instead.
 */
const PROMPT_COPY =
  'Sign in or create an account to save your little one’s dream wardrobe across your devices. ' +
  'Get notified when items go on sale, are low in stock, and share your child’s wishlist to ' +
  'family and friends.'

export const WishlistGuestPrompt = ({ onSignIn }) => (
  <div class="flex flex-col items-start gap-3 rounded bg-primary-white p-4" data-role="wishlist-drawer-guest">
    <p class="paragraph-sm">{PROMPT_COPY}</p>

    <button
      type="button"
      onClick={onSignIn}
      data-role="wishlist-drawer-guest-login"
      class="btn btn-md btn-outline-black w-full"
    >
      Sign in or create an account
    </button>
  </div>
)
